// extracted by mini-css-extract-plugin
export default {"header-img":"ZRLtz","content-container":"aXGuA","link":"zVJxf"};